<template>
  <b-button
    class="btn-main"
    :variant="variant"
    :disabled="disabled"
    :title="title"
    :tabindex="tabindex"
    @click="$emit('click')"
  >
    <fa-icon
      class="inner-icon"
      :icon="icon"
    />
  </b-button>
</template>

<script>

export default {
    name: 'VtIconButton',
    props: {
        icon: { type: [String, Array], required: true },
        title: { type: String },
        variant: { type: String, default: 'vt-light' },
        disabled: { type: Boolean },
        tabindex: { type: Number, default: 0 }
    }
}

</script>

<style scoped lang="scss">

.svg-inline--fa{
  font-size: 1rem;
}

.vt-icon-button {
  font-size: 19px;
  background-color: transparent;
  border: none;

  .inner-icon {
    width: 19px;
  }

  &.btn-danger {
    color: vt-color(red);

    &:hover,
    &:active,
    &:focus:active,
    &:focus {
      color: vt-color(dark-red);
      background-color: transparent;
      border: none;
      box-shadow: none;
    }
  }
}

</style>
